import React from "react";
import { FormattedMessage } from "react-intl";

export default class MenuItemText extends React.Component {
	render() {
		const { item, parentItem } = this.props;

		return (
			<>
				{item.icon && <div className="kt-menu__link-icon">{item.icon()}</div>}

				{parentItem && parentItem.bullet === "dot" && (
					<i className="kt-menu__link-bullet kt-menu__link-bullet--dot">
						<span />
					</i>
				)}

				{parentItem && parentItem.bullet === "line" && (
					<i className="kt-menu__link-bullet kt-menu__link-bullet--line">
						<span />
					</i>
				)}

				{item.translate ? (
					<span className="kt-menu__link-text" style={{ whiteSpace: "nowrap" }}>
						<FormattedMessage id={item.translate} defaultMessage={item.title} />
					</span>
				) : (
					<span
						className="kt-menu__link-text"
						style={{ whiteSpace: "nowrap" }}
						dangerouslySetInnerHTML={{ __html: item.title }}
					/>
				)}

				{item.badge && (
					<span className="kt-menu__link-badge">
						<span className={`kt-badge ${item.badge.type}`}>
							{item.badge.value}
						</span>
					</span>
				)}

				{item.submenu && <i />}
			</>
		);
	}
}
